import {createFileRoute} from '@tanstack/react-router';
import {RootQueryErrorScreen} from 'shared';

import {App} from '@/App';
import {LoadingScreen} from '@/components/LoadingScreen/LoadingScreen';
import {userKeys} from '@/features/User/api/queryKeys';
import {getWhoami} from '@/features/User/api/whoami';

export const Route = createFileRoute('/_b')({
  component: App,
  pendingComponent: LoadingScreen,
  errorComponent: RootQueryErrorScreen,

  loader({context}) {
    return context.queryClient.ensureQueryData({
      queryKey: userKeys.whoami,
      queryFn: () => getWhoami(),
    });
  },
});
